import { type FulfillmentRequestApi } from '@entities/fulfillment-request'

import { type WizardValues } from '../model/types'

type ServerField = keyof FulfillmentRequestApi.SaveRequest
export type WizardServerErrorField = keyof WizardValues | 'root.serverError'
export type WizardServerError = { field: WizardServerErrorField; message: string }

const wizardFieldByServerField = {
  title: 'title',
  shipment_types: 'shipmentTypes',
  marketplaces: 'marketplaces',
  marketplace_other_name: 'marketplaceOtherName',
  cities: 'cities',
  federal_districts: 'federalDistricts',
  warehouses: 'warehouses',
  services: 'services',
  subject_id: 'subjectId',
  subject_name: 'subjectName',
  product_url: 'productUrl',
  product_size: 'productSize',
  package_size: 'packageSize',
  unit_count: 'unitCount',
  due_date: 'dueDate',
  description: 'description',
  packing_type: 'packingType',
  packing_comment: 'packingComment',
  special_packing: 'specialPacking',
  needs_twice_a_day: 'needsTwiceADay',
  requirements: 'requirements',
  phone: 'phone',
  contacts: 'contacts',
} as const satisfies Record<ServerField, keyof WizardValues>

const getMessage = (error: unknown) => {
  if (typeof error === 'string') {
    return error
  }

  if (error !== null && typeof error === 'object' && 'message' in error && typeof error.message === 'string') {
    return error.message
  }

  return null
}

const getWizardField = (serverField: string): WizardServerErrorField => {
  if (Object.prototype.hasOwnProperty.call(wizardFieldByServerField, serverField)) {
    return wizardFieldByServerField[serverField as ServerField]
  }

  return 'root.serverError'
}

/** Переводит ошибки строгого серверного тела в поля мастера. */
export const mapServerErrors = (errors: unknown): WizardServerError[] => {
  if (errors === null || typeof errors !== 'object' || Array.isArray(errors)) {
    return []
  }

  return Object.entries(errors).flatMap(([serverField, error]) => {
    const message = getMessage(error)

    return message ? [{ field: getWizardField(serverField), message }] : []
  })
}
